import React, { FC } from 'react';
import { Button, Icon, Types } from '@marriott/mi-ui-library';
import { SavedCardRowProps } from '../WalletSavedCardsSection.types';
import { WALLET_SAVED_CARDS_TEST_IDS } from '../WalletSavedCardsSection.constants';
import { StyledSavedCardRow } from './SavedCardRow.styles';
import { getMaskedDot } from '../../../modules';

/**
 * SavedCardRow - Displays a single saved card with edit/delete/folio delivery actions
 * Presentational component that receives card data and callbacks from parent
 */
export const SavedCardRow: FC<SavedCardRowProps> = ({
  card,
  primaryLabel,
  editCtaLabel,
  editCtaAriaLabel,
  onEditClick,
  testId,
  trackingProperties,
  customClickTrackValue,
}) => {
  const handleEditClick = () => {
    onEditClick?.(card);
  };

  return (
    <StyledSavedCardRow data-testid={testId} className="wallet-saved-card-row">
      <div className="wallet-saved-cards-section__card-content">
        <div className="wallet-saved-cards-section__card-thumbnail" aria-hidden="true">
          {card.cardArt ? (
            <img src={card.cardArt} alt={card.cardType} className="wallet-saved-cards-section__card-art" />
          ) : (
            <span>{card.cardType?.substring(0, 2).toUpperCase() || 'CC'}</span>
          )}
        </div>

        <div className="wallet-saved-cards-section__card-info">
          <div className="wallet-saved-cards-section__card-number-wrapper">
            <p className="wallet-saved-cards-section__card-number">
              {getMaskedDot(false)} {card.cardNumber}
            </p>
          </div>
          <p className="wallet-saved-cards-section__cardholder-name">{card.cardholderName}</p>
          {card.isPrimary && primaryLabel ? (
            <span
              className="wallet-saved-cards-section__primary-badge"
              data-testid={WALLET_SAVED_CARDS_TEST_IDS.primaryBadge}
            >
              <Icon iconClass="icon-star" isDecorative ariaLabel="" />
              {primaryLabel}
            </span>
          ) : null}
        </div>
      </div>

      {/* Actions */}
      <div className="wallet-saved-cards-section__card-actions">
        <Button
          isLink={false}
          type={Types.ButtonTypeVariation.Button}
          className="wallet-saved-cards-section__action-button"
          callback={handleEditClick}
          buttonCopy={editCtaLabel}
          ariaLabel={editCtaAriaLabel || editCtaLabel}
          testId={WALLET_SAVED_CARDS_TEST_IDS.editCta}
          trackingProperties={trackingProperties}
          custom_click_track_value={customClickTrackValue}
        />
      </div>
    </StyledSavedCardRow>
  );
};
